<div class="input-container">
  <!-- Inserir data manualmente -->
  <ion-input
    mask="date"
    [formControl]="control"
    (ionBlur)="formatDateInput($event)"
    placeholder="{{ 'COMPONENTS.FORMS.INFORM_THE_DATE' | translate }}"
  >
  </ion-input>
  <ion-button fill="clear" class="calendar-button" (click)="datePicker.open()">
    <ion-icon name="calendar-outline"></ion-icon>
  </ion-button>
</div>

<!-- Inserir data pelo calendario -->
<ion-datetime
  displayFormat="DD/MM/YYYY"
  (ionChange)="onDateChange($event)"
  [max]="maxDate"
  #datePicker
  hidden
  doneText="{{ 'COMPONENTS.MODALS.CONFIRM' | translate }}"
  cancelText="{{ 'COMPONENTS.FORMS.CANCEL' | translate }}"
>
</ion-datetime>
